module.exports = __webpack_public_path__ + "img/play_right.e221e55d.png";